import React, { useState, } from 'react';
import classNames from 'classnames';
import Draggable from 'react-draggable';
import style from './index.module.less';


const DraggablePanel: React.FC = () => {

  const [show, setShow] = useState(true);

  return (
    <Draggable handle=".handle" >
      <div
        className={classNames(style.draggablePanel, show ? style.show : style.hide)}
      >
        <div className={classNames(style.top, 'handle')}><div className={style.close} onClick={() => {setShow(false);}}></div></div>
        <div className={style.main}>
        To see the instructions for the test, click on the arrow (v); after that, click 'I confirm' and then 'Start' to start the test. In the real test you’ll only be able to see this once.
        </div>
      </div>
    </Draggable>
  );
};

export default DraggablePanel;